import React from 'react';
import { ExamQuestion } from '../types';

interface ExamOpticalFormProps {
    questions: ExamQuestion[];
    currentQuestionIndex: number;
    answers: { [questionId: number]: string };
    bookmarks: number[];
    onQuestionSelect: (index: number) => void;
}

export const ExamOpticalForm: React.FC<ExamOpticalFormProps> = ({
    questions,
    currentQuestionIndex,
    answers,
    bookmarks,
    onQuestionSelect
}) => {
    // Group questions by section
    const sections = questions.reduce((acc, q) => {
        if (!acc[q.section]) {
            acc[q.section] = [];
        }
        acc[q.section].push(q);
        return acc;
    }, {} as { [section: string]: ExamQuestion[] });

    return (
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden flex flex-col h-full">
            <div className="bg-gray-50 p-4 border-b font-bold text-gray-700 text-center">
                Optik Form
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-6">
                {Object.entries(sections).map(([sectionName, sectionQuestions]: [string, ExamQuestion[]]) => (
                    <div key={sectionName}>
                        <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3 border-b pb-1">{sectionName}</h4>
                        <div className="grid grid-cols-5 gap-2">
                            {sectionQuestions.map((q) => {
                                const isAnswered = !!answers[q.id];
                                const isCurrent = questions[currentQuestionIndex].id === q.id;
                                const isBookmarked = bookmarks.includes(q.id);
                                const index = questions.findIndex(ques => ques.id === q.id);

                                return (
                                    <button
                                        key={q.id}
                                        onClick={() => onQuestionSelect(index)}
                                        className={`
                                            relative h-8 w-full rounded flex items-center justify-center text-xs font-bold transition-all
                                            ${isCurrent
                                                ? 'ring-2 ring-blue-500 ring-offset-1 z-10'
                                                : 'hover:bg-gray-100'
                                            }
                                            ${isAnswered
                                                ? 'bg-blue-600 text-white'
                                                : 'bg-gray-50 text-gray-600 border border-gray-200'
                                            }
                                        `}
                                    >
                                        {q.questionNumber}
                                        {isBookmarked && (
                                            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-yellow-400 rounded-full border border-white" />
                                        )}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>

            <div className="p-4 bg-gray-50 border-t text-xs space-y-2">
                <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-blue-600 rounded"></span>
                    <span>Cevaplanmış</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-gray-50 border border-gray-200 rounded"></span>
                    <span>Boş</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="w-2.5 h-2.5 bg-yellow-400 rounded-full"></span>
                    <span>İşaretli</span>
                </div>
            </div>
        </div>
    );
};
